import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
  OnDestroy
} from '@angular/core';
import { filter, findIndex } from 'lodash';
import { SpecialOptionsFormsService } from './shared/special-options.form.service';
import { BaseControl, UpdateData, OrdenPestanas, Pestana } from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { OpcionesEspeciales } from '../view-form/view-form.component';
import { FormGroup } from '@angular/forms';
import { SpecialOptionsConfigService } from './shared/special-options.config.service';
import { LocalDataSource } from 'ng2-smart-table';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-special-options',
  templateUrl: './special-options.component.html',
  styleUrls: ['./special-options.component.scss'],
  providers: [SpecialOptionsFormsService]
})
export class SpecialOptionsComponent implements OnInit, OnDestroy {

  // Define si la forma tiene la propieda de gestion de documentos
  @Input() documentManagement: boolean;
  // Define si la forma tiene la propiedad de radicacion
  @Input() radication: boolean;
  // Define si la forma tiene la propieda de anexos
  @Input() annexed: boolean;
  // Define si la forma tiene la propieda de revisiones
  @Input() revisions: boolean;
  // Define si la forma tiene la propieda de radicación especial
  @Input() special_radication: boolean;
  // Define si la forma tiene la propieda de con copia a funcionarios
  @Input() functionary: boolean;
  // Define si la forma tiene la propieda de revision
  @Input() remision: boolean;
  // Define si la forma tiene la propieda de enviado por
  @Input() sendedby: boolean;
  // Define si la forma tiene la propieda de En respuesta De
  @Input() response: boolean;
  // Informacion del formulario
  @Input() dataForm: OpcionesEspeciales;
  // Formulario de opciones especiales
  form: FormGroup;
  // Referencia de la modal
  modalRef: BsModalRef;
  // Contiene los nombres de la pestañas
  tabsName = {
    revisiones: 'Aprobar / Firmar documentos',
    formularios: 'Formularios',
    gestion_documentos: 'Generar / Subir documentos',
    radicacion: 'Radicar / Asociar documentos',
    anexos: 'Anexos',
    radicacion_especial: 'Radicación',
    remision_funcionarios: 'Destinatarios',
    enviado_por: 'Enviado por',
    con_copia_a: 'Con copia a',
    en_respuesta_de: 'En respuesta de'
  };
  // Contiene la configuracion de la tabla
  settings: any = {};
  // Contiene los registros de la tabla
  source: LocalDataSource;
  // Controles del formulario de opciones especiales
  controls: BaseControl<any>[];
  // Contiene el orden de las péstañas
  tabs: OrdenPestanas[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al template de la modal de duplicacion de forma
  @ViewChild('templateModal') private templateModal: TemplateRef<any>;
  // Evento de salida con los parametros guardados
  @Output() saveSpecialOptions: EventEmitter<OpcionesEspeciales> = new EventEmitter();

  constructor(
    private sofs: SpecialOptionsFormsService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) { }

  ngOnInit() { }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Función que abre el componente
   *
   * @memberof SpecialOptionsComponent
   */
  open() {
    if (this.documentManagement || this.radication || this.annexed || this.revisions || this.special_radication) {
      this.modalRef = this.modalService.show(this.templateModal, { class: 'modal-lg'});
      this.loadTabsInTable();
      this.controls = this.sofs.getFormSpecialOptions(this.dataForm);
    } else {
      this.toastr.error(
        'Para acceder a las opciones especiales la forma debe tener al menos una acción sobre documentos.',
        'Configuraciones bloqueadas'
      );
    }
  }


  /**
   * Controla acción de guardar del formulario de opciones especiales
   *
   * @param {*} data
   * @memberof SpecialOptionsComponent
   */
  savedForm() {
    if (this.form.valid) {
      const specialOptions: OpcionesEspeciales = {
        orden_pestanas: this.form.value['chkDefinirOrdenPestanas'] ? this.tabs : null
      };
      this.toastr.success('Opciones especiales guardadas correctamente', 'Operación exitosa');
      this.saveSpecialOptions.emit(specialOptions);
      this.closeModal();
    }
  }

  /**
   * Cerrar modal de opciones especiales
   *
   * @memberof SpecialOptionsComponent
   */
  closeModal() {
    this.controls = [];
    this.tabs = [];
    this.modalRef.hide();
  }

  /**
   * Carga la lista de pestañas para la tabla
   *
   * @private
   * @memberof SpecialOptionsComponent
   */
  private loadTabsInTable() {
    if (this.dataForm && this.dataForm.orden_pestanas && this.dataForm.orden_pestanas.length) {
      this.tabs = filter(this.dataForm.orden_pestanas, el => {
        if (this.documentManagement && el.pestana === 'gestion_documentos') {
          return el;
        }
        if (this.radication && el.pestana === 'radicacion') {
          return el;
        }
        if (this.annexed && el.pestana === 'anexos') {
          return el;
        }
        if (this.revisions && el.pestana === 'revisiones') {
          return el;
        }
        if(this.special_radication && el.pestana === 'radicacion_especial'){
          return el;
        }
        if(this.functionary && el.pestana === 'remision_funcionarios'){
          return el;
        }
        if(this.remision && el.pestana === 'con_copia_a'){
          return el;
        }
        if(this.sendedby && el.pestana === 'enviado_por'){
          return el;
        }
        if(this.response && el.pestana === 'en_respuesta_de'){
          return el;
        }
        if (el.pestana === 'formularios') {
          return el;
        }
      });
    }
    if (this.revisions) {
      this.updateListTabs('revisiones', 'add');
    } else {
      this.updateListTabs('revisiones', 'remove');
    }
    this.updateListTabs('formularios', 'add');
    if (this.documentManagement) {
      this.updateListTabs('gestion_documentos', 'add');
    } else {
      this.updateListTabs('gestion_documentos', 'remove');
    }
    if (this.radication) {
      this.updateListTabs('radicacion', 'add');
    } else {
      this.updateListTabs('radicacion', 'remove');
    }
    if (this.annexed) {
      this.updateListTabs('anexos', 'add');
    } else {
      this.updateListTabs('anexos', 'remove');
    }
    if(this.special_radication){
      this.updateListTabs('radicacion_especial', 'add');
    }else{
      this.updateListTabs('radicacion_especial', 'remove');
    }
    if(this.remision){
      this.updateListTabs('remision_funcionarios', 'add');
    }else{
      this.updateListTabs('remision_funcionarios', 'remove');
    }
    if(this.functionary){
      this.updateListTabs('con_copia_a', 'add');
    }else{
      this.updateListTabs('con_copia_a', 'remove');
    }
    if(this.sendedby){
      this.updateListTabs('enviado_por', 'add');
    }else{
      this.updateListTabs('enviado_por', 'remove');
    }
    if(this.response){
      this.updateListTabs('en_respuesta_de', 'add');
    }else{
      this.updateListTabs('en_respuesta_de', 'remove');
    }

    this.tabs.forEach((tab, i) => {
      tab['index'] = i;
      tab.orden = i + 1;
    });
    this.source = new LocalDataSource(this.tabs);
    this.configTable();
  }

  /**
   * Actualiza la lista de ordenes de pestañas agregando o quitando segun sea el caso la pestaña del orden
   *
   * @private
   * @param {Pestana} tab
   * @param {('add' | 'remove')} action
   * @memberof SpecialOptionsComponent
   */
  private updateListTabs(tab: Pestana, action: 'add' | 'remove') {
    const exist = findIndex(this.tabs, {pestana: tab});
    if (exist === -1 && action === 'add') {
      const nextOrden = this.tabs.length ? Number(this.tabs[this.tabs.length - 1].orden) + 1 : 1;
      this.tabs.push({
        orden: nextOrden,
        pestana: tab,
        requerido: false,
        nombre: this.tabsName[tab]
      });
    } else if (exist !== -1 && action === 'remove') {
      this.tabs.splice(exist, 1);
    }
  }

  /**
   * Configura la tabla de orden de pestañas
   *
   * @private
   * @memberof SpecialOptionsComponent
   */
  private configTable() {
    const controlsOrder = this.sofs.getTabOrderForm(this.tabs.length);
    const controlsRequired = this.sofs.getRequiredTabForm();
    const controlsName = this.sofs.getTabNameForm();
    const config: SpecialOptionsConfigService = new SpecialOptionsConfigService();
    config.getConfigTable(controlsOrder, controlsRequired, controlsName);
    this.settings = config.settings;
    config.updated.subscribe((data: UpdateData) => this.updatedOrderTabs(data));
  }

  /**
   * Actualiza la tabla cuando se realiza un cambio en la informacion
   *
   * @private
   * @param {UpdateData} data
   * @memberof SpecialOptionsComponent
   */
  private updatedOrderTabs(data: UpdateData) {
    if (data.saved) {
      let exist = findIndex(
        this.tabs,
        tab => {
          if (Number(tab.orden) === Number(data.row['orden']) && Number(tab['index']) !== Number(data.row['index'])) {
            return tab;
          }
        }
      );
      this.tabs[data.row['index']] = data.row;
      if (exist !== -1) {
        let update = true;
        if (exist > data.row['index']) {
          while (update) {
            this.tabs[exist].orden = this.tabs[exist].orden - 1;
            exist = exist - 1;
            if (exist === 0) {
              update = false;
            } else if (exist === data.row['index']) {
              update = false;
            }
          }
        } else if (exist < data.row['index']) {
          while (update) {
            this.tabs[exist].orden = this.tabs[exist].orden + 1;
            exist = exist + 1;
            if (exist === (this.tabs.length - 1)) {
              update = false;
            } else if (exist === data.row['index']) {
              update = false;
            }
          }
        }
        this.tabs.sort((a, b) => a.orden - b.orden);
        if (!update) {
          this.tabs.forEach((tab, i) => {
            tab['index'] = i;
          });
        }
      }
      this.source.refresh();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/special-options/special-options.component.ts